import find from 'lodash/find';

import {
  sendRequest
} from 'zoomforth_zfutils/xhr_tools.js';

import {
  getPageId,
  getThemes
} from 'zoomforth_codesbane_editor/reducers/index.js';

import {
  fetchThemes,
  setCurrentTheme
} from './theme.js';

import {
  ensureThrottledPageConfigSaving
} from './config.js';

import {
  showModal
} from './editor_modals.js';

import {
  notifyErrorMaybeLostData
} from './misc.js';

import {
  LATEST_SITE_VIEWER_VERSION
} from 'sites_const_shared/site_viewer_versions.js';

import {
  SET_SITE_VIEWER_VERSION,
  SET_SITE_VIEWER_VERSION_META,
  DISMISS_SITE_VIEWER_VERSION_UPGRADE
} from 'zoomforth_codesbane_editor/action_types.js';

import UpgradeSiteViewerVersionModal
  from 'zoomforth_codesbane_editor/exterior_editor/editor_modals/upgrade_site_viewer_version_modal_container.jsx';

export const showUpgradeSiteViewerVersionModal = ({ shouldFetchThemes = false } = {})=>
  (dispatch)=> {
    // Begin fetching themes so the user can be told if they need to change to
    // an accessible theme. This isn't always required though. If the user is
    // opening this modal from the sidebar style selector then we already load
    // themes. If this modal is shown on initial editor load then we want to
    // make the fetch now.
    if (shouldFetchThemes) {
      dispatch(fetchThemes());
    }

    dispatch(showModal(UpgradeSiteViewerVersionModal));
  };

export const fetchSiteViewerVersionUpgradeMeta = ({ shouldShowUpgradeModal = true } = {})=>
  (dispatch, getState)=> {
    sendRequest({
      url: `/rpc/pages/get-upgrade-meta/${getPageId(getState())}`,
      method: 'GET',
      onSuccess: (data)=> {
        const {
          isUpgradeAvailable,
          hasUserDismissedUpgrade
        } = data;

        dispatch({
          type: SET_SITE_VIEWER_VERSION_META,
          isUpgradeAvailable,
          hasUserDismissedUpgrade
        });

        if (shouldShowUpgradeModal && isUpgradeAvailable && !hasUserDismissedUpgrade) {
          dispatch(showUpgradeSiteViewerVersionModal({
            shouldFetchThemes: true
          }));
        }
      }
    });
  };

export const dismissUpgradeSiteViewerVersion = ()=>
  (dispatch, getState)=> {
    sendRequest({
      url: '/rpc/pages/dismiss-site-viewer-version-upgrade',
      method: 'POST',
      params: {
        site_id: getPageId(getState())
      },
      onSuccess: ()=> {
        dispatch({ type: DISMISS_SITE_VIEWER_VERSION_UPGRADE });
      },
      onError: ({ status })=> {
        dispatch(notifyErrorMaybeLostData(
          status,
          'There was an issue while dismissing this upgrade'
        ));
      }
    });
  };

export const upgradeSiteViewerVersion = (themeUuid, mappedStylePresets)=>
  (dispatch, getState)=> {
    const allThemes = getThemes(getState());
    const themeData = find(allThemes, ['uuid', themeUuid]);

    // set the actual site viewer version on the config
    dispatch({
      type: SET_SITE_VIEWER_VERSION,
      siteViewerVersion: LATEST_SITE_VIEWER_VERSION
    });

    dispatch(ensureThrottledPageConfigSaving());

    // set the upgrade state without making a new server fetch
    dispatch({
      type: SET_SITE_VIEWER_VERSION_META,
      isUpgradeAvailable: false,
      hasUserDismissedUpgrade: true
    });

    // set the theme to use the selected one from the upgrade flow
    dispatch(setCurrentTheme(themeData, mappedStylePresets));
  };
